import {GALinkStatus} from '../../util/uiconstants';
import {currentResource} from '../../util/utils';

const checkDisabled = (linkStatusId) => {
	return (
		linkStatusId === GALinkStatus.ComponentNotUsingCanvas ||
		linkStatusId === GALinkStatus.ComponentReferenceOnly ||
		linkStatusId === GALinkStatus.InvalidPointOfContact ||
		linkStatusId === GALinkStatus.Unlinked ||
		linkStatusId === GALinkStatus.NoPointOfContact ||
		linkStatusId === GALinkStatus.NotSent
	);
};

const isChecked = (sentDate, publishDate) => {
	if (sentDate) return Date.parse(sentDate) < Date.parse(publishDate);

	return publishDate !== null;
};

const mapScope = ({gaScopeId: id, gaScopeName: label, type, scopeInstructionSentDate, isSubScope, teamList}) => ({
	id,
	type,
	label,
	isSubScope,
	scopeInstructionSentDate,
	selected: false,
	disabled: false,
	teamList: teamList
		.sort((a, b) => {
			return a.teamName.toLowerCase().localeCompare(b.teamName.toLowerCase());
		})
		.map(
			({
				gaComponentId: teamId,
				teamName,
				teamInstructionSentDate,
				scopePublishDate: scopeInstructionSentDate,
				gaLinkStatusId: linkStatusId
			}) => ({
				teamId,
				teamName,
				teamInstructionSentDate,
				scopeInstructionSentDate,
				linkStatusId,
				error: false,
				selected: !checkDisabled(linkStatusId) && isChecked(teamInstructionSentDate, scopeInstructionSentDate),
				disabled: checkDisabled(linkStatusId)
			})
		)
});

export default (scopes) => {
	const mappedScopes = scopes.map(mapScope);
	let normalizedScopes = [];

	currentResource.gaScopesResource.forEach(({id, label}) => {
		normalizedScopes = [
			...normalizedScopes,
			...mappedScopes.filter(({isSubScope, type}) => !isSubScope && type === id).map((s) => ({...s, label})),
			...mappedScopes
				.filter(({isSubScope, type}) => isSubScope && type === id)
				.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
		];
	});

	return normalizedScopes;
};
